import React from "react";
import { Link } from "react-router-dom";

const Order = ({ userRelatedData }) => {
  return (
    <section>
      <div className="container theme-section">
        <h1 className="section-tittle">Recent Order</h1>

        <div className="data-table-wrapper" display-all="false">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Pick Up Date</th>
                  <th>Delivery Date</th>
                  <th>Carrier</th>
                  <th>Origin</th>
                  <th>Destination</th>
                  <th>Total Cost</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {userRelatedData.last_five_order_list?.length > 0 ? (
                  userRelatedData.last_five_order_list?.map((value, index) => (
                    <tr>
                      <td>{value.load_post.pickup_date}</td>
                      <td>{value.load_post.delivery_date}</td>
                      <td>{value.carrier_name}</td>
                      <td>{value.load_post.origin_address}</td>
                      <td>{value.load_post.destination_address}</td>
                      <td>{value.amount}</td>
                      <td className="text-end">
                        <Link to={"/order/details/" + value.id}>Expand</Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>No Order data available</tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="multiple-btn mt-4">
          <Link to="/order/order-list">View All Orders</Link>
        </div>
      </div>
    </section>
  );
};

export default React.memo(Order);
